import { render, staticRenderFns } from "./PollNumberResults.vue?vue&type=template&id=0267e54b&scoped=true"
import script from "./PollNumberResults.vue?vue&type=script&lang=js"
export * from "./PollNumberResults.vue?vue&type=script&lang=js"
import style0 from "./PollNumberResults.vue?vue&type=style&index=0&id=0267e54b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0267e54b",
  null
  
)

export default component.exports